import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import * as HomeCareActionType from '../constants';

class HomeCareList extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    lot: PropTypes.object,
    categories: PropTypes.array,
    articlesList: PropTypes.array,
    selectedCategory: PropTypes.any,
    loading: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      localSelectedCategory: null,
      previewModalOpen: false,
      previewContent: null
    };
  }

  componentDidMount() {
    this.loadCategories();
  }

  loadCategories = () => {
    this.props.dispatch({
      type: HomeCareActionType.GET_ARTICLES_CATEGORIES_ASYNC,
      callback: (data) => {
        // Auto-select first category after loading
        if (data && data.length > 0) {
          this.handleCategoryClick(data[0]);
        }
      }
    });
  };

  handleCategoryClick = (category) => {
    this.setState({ localSelectedCategory: category.id });
    this.props.dispatch({
      type: HomeCareActionType.GET_ARTICLES_LIST_ASYNC,
      params: { id: category.category }
    });
  };

  openPreview = (article) => {
    const url = article.url || article.documentUrl || article.textAndUrl || '';
    const fileName = article.title || article.name || article.fileName || 'Document';
    
    this.setState({
      previewModalOpen: true,
      previewContent: {
        url,
        fileName
      }
    });
  };

  closePreview = () => {
    this.setState({
      previewModalOpen: false,
      previewContent: null
    });
  };

  renderPreviewModal = () => {
    const { previewModalOpen, previewContent } = this.state;
    if (!previewContent) return null;

    return (
      <Modal
        show={previewModalOpen}
        onHide={this.closePreview}
        centered
        className="custom-preview-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewContent.fileName}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center', minHeight: '500px' }}>
          <div style={{ height: '70vh', width: '100%' }}>
            <iframe
              src={previewContent.url}
              title={previewContent.fileName}
              style={{
                width: '100%',
                height: '100%',
                border: 'none'
              }}
              frameBorder="0"
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  render() {
    const { categories, articlesList, loading } = this.props;
    const { localSelectedCategory } = this.state;

    return (
      <div className="home-care-list" style={{ display: 'flex', height: '100vh', backgroundColor: '#f5f5f5' }}>
        {/* Left Sidebar - Categories */}
        <div style={{
          width: '280px',
          backgroundColor: 'white',
          borderRight: '1px solid #e0e0e0',
          overflowY: 'auto',
          padding: '20px 15px'
        }}>
          
          {loading && categories.length === 0 ? (
            <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
              Loading categories...
            </div>
          ) : (
            categories.map((category) => (
              <div
                key={category.id}
                onClick={() => this.handleCategoryClick(category)}
                style={{
                  padding: '15px',
                  marginBottom: '10px',
                  border: localSelectedCategory === category.id ? '2px solid #4285f4' : '1px solid #e0e0e0',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  backgroundColor: localSelectedCategory === category.id ? '#e8f0fe' : 'white',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => {
                  if (localSelectedCategory !== category.id) {
                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                  }
                }}
                onMouseLeave={(e) => {
                  if (localSelectedCategory !== category.id) {
                    e.currentTarget.style.backgroundColor = 'white';
                  }
                }}
              >
                <i className="fa fa-folder-o" style={{
                  fontSize: '20px',
                  color: '#666',
                  marginRight: '12px'
                }}></i>
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontSize: '14px',
                    color: '#333',
                    fontWeight: '500'
                  }}>
                    {category.categoryName}
                  </div>
                </div>
                
              </div>
            ))
          )}
        </div>

        {/* Right Content - Articles List */}
        <div style={{
          flex: 1,
          padding: '30px',
          overflowY: 'auto'
        }}>
          {loading && articlesList.length === 0 ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
              {/* <i className="fa fa-spinner fa-spin" style={{ fontSize: '32px', marginBottom: '10px' }}></i>
              <div>Loading articles...</div> */}
            </div>
          ) : articlesList && articlesList.length > 0 ? (
            <div>
              {articlesList.map((article, index) => (
                <div
                  key={index}
                  onClick={() => this.openPreview(article)}
                  style={{
                    display: 'flex',
                    padding: '15px',
                    marginBottom: '10px',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  {/* File Icon */}
                  <div style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    marginRight: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                  }}>
                    <i className="fa fa-file-pdf-o" style={{ fontSize: '24px', color: '#d32f2f' }}></i>
                  </div>

                  {/* Article Info */}
                  <div style={{ flex: 1 }}>
                    <div style={{
                      fontSize: '14px',
                      color: '#333',
                      fontWeight: '500',
                      marginBottom: '4px'
                    }}>
                      {article.title || article.name || 'Untitled'}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#999'
                    }}>
                      {article.date || article.createdAt || ''}
                    </div>
                  </div>

                  {/* Arrow Icon */}
                  <i className="fa fa-chevron-right" style={{
                    color: '#999',
                    fontSize: '14px',
                    padding: '10px'
                  }}></i>
                </div>
              ))}
            </div>
          ) : (
            <div style={{
              padding: '60px',
              textAlign: 'center',
              color: '#999'
            }}>
              <i className="fa fa-folder-open-o" style={{ fontSize: '48px', marginBottom: '15px', opacity: 0.5 }}></i>
              <div style={{ fontSize: '16px' }}>
                {localSelectedCategory ? 'No articles found in this category' : 'Select a category to view articles'}
              </div>
            </div>
          )}
        </div>

        {/* PDF Preview Modal */}
        {this.renderPreviewModal()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    categories: (state.HomeCareStore && state.HomeCareStore.categories) || [],
    articlesList: (state.HomeCareStore && state.HomeCareStore.articlesList) || [],
    selectedCategory: state.HomeCareStore && state.HomeCareStore.selectedCategory,
    loading: (state.HomeCareStore && state.HomeCareStore.loading) || false
  };
};

export default connect(mapStateToProps)(HomeCareList);



// WEBPACK FOOTER //
// ./src/HomeCare/Components/home-care-list.js